<template>
    <el-dialog class="haveTable" :title="title" width="50%" append-to-body :close-on-click-modal="false" :visible.sync="visible">
        <div class="el-table-container">
            <div class="flex_b_c m_b1">
                <div>当前模型名称：{{info.consistencyName}}</div>
                <div>维度数：{{info.dimensionalityNum}}条 原子数：{{info.atomNum}}条</div>
            </div>
            <el-table
                    :data="dataList"
                    v-loading="loading"
                    size="small" height="100%"
                    class="table" border>
                <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="consistencyName" label="比对模型名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="dimensionalityNum" label="维度条目数" show-overflow-tooltip></el-table-column>
                <el-table-column prop="alikeDimensionalityNum" label="相同维度条目数" show-overflow-tooltip
                                 v-if="step == 2"></el-table-column>
                <el-table-column prop="atomNum" label="原子条目数" show-overflow-tooltip></el-table-column>
                <el-table-column prop="alikeAtomNum" label="相同原子条目数" show-overflow-tooltip
                                 v-if="step == 2"></el-table-column>
                <el-table-column fixed="right" label="操作" v-if="step == 2">
                    <template slot-scope="{row}">
                        <el-button type="text" size="small" @click="view(row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                        @pagination="refreshList"/>
        </div>
        <div slot="footer">
            <el-button size="small" @click="visible = false">关闭</el-button>
            <el-button size="small" type="primary" @click="modelComparison()" v-noMoreClick v-if="step == 1">模型比对
            </el-button>
        </div>
        <ModelComparisonResultView ref="modelComparisonResultView"></ModelComparisonResultView>
    </el-dialog>
</template>

<script>
    import ModelComparisonResultView from './modelComparisonResultView'

    export default {
        components: {ModelComparisonResultView},
        data() {
            return {
                visible: false,
                loading: false,
                title: '选择比对模型',
                step: 1,
                info: {},
                dataList: [],
                searchForm: {
                    current: 1,
                    size: 20,
                    basicDataId: '',
                },
                total: 0,
            }
        },
        watch: {
            'step'(val) {
                if (val == 1) {
                    this.title = '选择比对模型'
                } else if (val == 2) {
                    this.title = '模型比对结果'
                }
            },
        },
        methods: {
            init(id) {
                this.step = 1
                this.searchForm.basicDataId = id
                this.visible = true
                this.$nextTick(() => {
                    this.getNum()
                    this.refreshList()
                })
            },
            getNum() {
                this.$axios(this.api.metadata.currentDimensionalityAtomNum, {basicDataId: this.searchForm.basicDataId}).then(data => {
                    if (data.status) {
                        this.info = data.data
                    }
                })
            },
            refreshList() {
                let api = this.api.metadata.otherDimensionalityAtomNum
                if (this.step == 2) {
                    api = this.api.metadata.compareResult
                }
                this.loading = true
                this.$axios(api, this.searchForm).then(data => {
                    if (data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                        this.loading = false
                    } else {
                        this.$message.error('查询失败');
                    }
                })
            },
            // 模型比对
            modelComparison() {
                this.dataList = []
                this.total = 0
                this.searchForm.current = 1
                this.step = 2
                this.refreshList()
            },
            // 查看
            view(row) {
                this.$refs.modelComparisonResultView.init(this.searchForm.basicDataId, this.info.consistencyName, row)
            },
        }
    }
</script>

<style scoped>
</style>
